<template>
  <Modal v-model="systemAnnouncementModal" class-name="systemAnnouncementStyle" :title="systemAnnouncementTitle" width="1000"
    :transfer="false" :mask-closable="false" @on-visible-change="systemAnnouncementChange">
    <Form :model="systemAnnouncementForm" ref="systemAnnouncementForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003073')" prop="title">
            <Input v-model.trim="systemAnnouncementForm.title" :placeholder="$t('key1003061')" :element-id="'guideTitle'"
              clearable style="width:300px">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002961')" prop="subsystemName">
            <Select v-model="systemAnnouncementForm.subsystemName" transfer style="width:300px" multiple>
              <Option v-for="item in notificationObjectList" :key="item.value" :value="item.value">{{ item.value }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002963')" prop="effectiveStartTime">
            <div class="flex align-items-center">
              <DatePicker
                transfer
                v-model="systemAnnouncementForm.effectiveStartTime"
                :options="options"
                @on-clear="resetDate"
                type="datetime"
                :placeholder="$t('key1000101')"
                format="yyyy-MM-dd HH:mm:ss"
                style="width:300px">
              </DatePicker>
              <Tooltip max-width="400" placement="top" class="ml5 cursor" transfer :content="$t('key1003074')">
                <Icon size="18" type="md-help-circle"/>
              </Tooltip>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="editor_style">
          <Form-item :label="$t('key1003033')" prop="context" label-position="top" class="required_style_label">
            <UE
              v-if="initFinished"
              :disabled="false"
              :content.sync="systemAnnouncementForm.context || ''"
              :htmlStatus="false"
              id="systemAnnouncementForm.add.description"
              :config=config
              ref="ueBox">
            </UE>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button class="ml15" @click="systemAnnouncementModal = false">{{ $t('key1000112') }}</Button>
      <Button class="ml15" @click="systemAnnouncementBtn(1)">{{ $t('key1003075') }}</Button>
      <Button class="ml15" type="primary" @click="systemAnnouncementBtn(3)">{{ $t('key1003076') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import UE from "@/components/common/ue.vue";

export default {
  name: "systemAnnouncementModal",
  components: {UE},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      systemAnnouncementTitle: '',
      systemAnnouncementModal: false,
      systemAnnouncementForm: {
        context: '', // 公告内容
        effectiveStartTime: null, // 生效开始时间
        subsystemName: [],
        title: ''
      },
      ruleValidate: {
        title: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003067'), trigger: 'blur'}
        ],
        subsystemName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003068'), trigger: 'change', type: 'array'}
        ],
        effectiveStartTime: [
          {required: true, type: 'date', validator: v.validateTimer(), trigger: 'change'},
        ]
      },
      timeValue: [],
      notificationObjectList: [
        {value: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000015')},
        {value: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014')}
      ],
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 380,
        serverUrl: api.get_erpCommon_ueditorEnter,
        wordCount: false,
        autoHeightEnabled: false,
        imageScaleEnabled: false,
        elementPathEnabled: false, // 禁止显示元素路径
      },
      systemAnnouncementType: 'add',
      noticeInfoId: null,
      contextTalg: false,
      isFocused: false,
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 8.64e7;
        }
      },
      initFinished: false,
    };
  },
  computed: {
    ueContent() {
      if (this.$refs['ueBox']) {
        return this.$refs['ueBox'].getUEContent();
      }
    }
  },
  methods: {
    // 初始化数据
    initSystemAnnouncementData(type, noticeInfoId) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002964'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003069')
      };
      this.systemAnnouncementTitle = obj[type];
      this.systemAnnouncementType = type;
      this.noticeInfoId = noticeInfoId;
      if (type == 'add') {
        this.systemAnnouncementModal = true;
        this.initFinished = true;
      } else {
        this.getSystemAnnouncementDetails(noticeInfoId);
      }
    },
    // 获取系统公告详情
    getSystemAnnouncementDetails(noticeInfoId) {
      this.axios.get(api.get_ymsNoticeInfo + noticeInfoId, null, {loading: true}).then((res) => {
        this.systemAnnouncementModal = true;
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            if (this.$refs.ueBox) {
              this.$refs.ueBox.setUEContent(data.context);
            }
            this.systemAnnouncementForm.context = data.context; // 公告内容
            this.systemAnnouncementForm.effectiveStartTime = data.effectiveStartTime ?
              this.$uDate.dealTime(data.effectiveStartTime, 'fulltime') : null; // 生效开始时间
            let noticeEffectiveScopeBos = data.noticeEffectiveScopeBos || [];
            if (noticeEffectiveScopeBos.length > 0) {
              this.systemAnnouncementForm.subsystemName = noticeEffectiveScopeBos.map((item) => {
                return item.subsystemName;
              });
            }
            this.systemAnnouncementForm.title = data.title;
          }
          this.initFinished = true;
        }
      });
    },
    // 提交审核、存为草稿
    systemAnnouncementBtn(type) {
      let v = this;
      let text = type === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003070');
      let url = '';
      let method = '';
      let params = {
        context: v.$refs['ueBox'].getUEContent(), // 公告内容
        effectiveEndTime: null, // 生效结束时间
        effectiveStartTime: v.$uDate.getUniversalTime(new Date(v.systemAnnouncementForm.effectiveStartTime).getTime(), 'fulltime'),
        link: null, // 公告链接
        noticeEffectiveScopeBos: [],
        productLine: 'YMS', // 产品线 ERP2.0、listing、ERP3.0、YMS
        status: type, // 状态 1草稿、2待修改、3待审核、4待发送、5已发送
        title: v.systemAnnouncementForm.title,
      };
      if (v.systemAnnouncementForm.subsystemName.length > 0) {
        v.systemAnnouncementForm.subsystemName.map((item) => {
          params.noticeEffectiveScopeBos.push({
            env: null,
            merchantId: null,
            subsystemName: item,
          });
        });
      }
      if (v.systemAnnouncementType === 'add') {
        url = api.post_ymsNoticeInfo;
        method = 'post';
      } else if (v.systemAnnouncementType === 'edit') {
        url = api.put_ymsNoticeInfo;
        method = 'put';
        params.noticeInfoId = v.noticeInfoId;
      }
      v.$refs['systemAnnouncementForm'].validate((valid, err) => {
        if (valid) {
          if (params.context) {
            v.axios[method](url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.systemAnnouncementModal = false;
                v.$emit('updateData', true);
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003071'));
            return false;
          }
        }
      });
    },
    // 重置发送时间
    resetDate() {
      let v = this;
      v.systemAnnouncementForm.effectiveStartTime = null;
    },
    // 监听弹窗
    systemAnnouncementChange(value) {
      let v = this;
      if (!value) {
        v.$refs['systemAnnouncementForm'].resetFields();
        v.noticeInfoId = null;
        v.timeValue = [];
        v.$refs.ueBox.setUEContent('');
      }
    },
    // 校验发送时间
    validateTimer() {
      return function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003072')));
        } else {
          callback();
        }
      };
    }
  },
  watch: {
    initFinished(n, o) {
      let v = this;
      if (n) {
        v.$nextTick(() => {
          let editor = v.$refs['ueBox'].editor;
          let userInfo = v.$store.state.erpConfig.userInfo;
          editor.addListener('ready', function () {
            editor.execCommand('serverparam', {
              'basePath': 'yms-core-service',
              'userId': userInfo.merchantId + ',' + userInfo.userId
            });
          });
        });
      }
    },
  }
};
</script>

<style lang="less" scoped>
.systemAnnouncementStyle {

  .editor_style {
    /deep/ .ivu-form-item-content {
      line-height: initial !important;
    }
  }

  .ivu-form-item-error {
    /deep/ .edui-editor {
      border: 1px solid #ed4014 !important;
    }
  }
}

/deep/ .ivu-modal-wrap {
  z-index: 1001 !important;
}

/deep/ .ivu-modal-mask {
  z-index: 1001 !important;
}
</style>